export const formatAgeGroup = (ageGroup) => {
    return `${ageGroup}u`;
};
export const renderAgeGroup = (ageGroup, options = { shouldDisplay: true }) => {
    if (ageGroup && options.shouldDisplay) {
        return formatAgeGroup(ageGroup);
    }
    return undefined;
};
